module.exports = __webpack_public_path__ + "static/media/escudo-01.ba5f23be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/escudo-01.svg
// module id = 458
// module chunks = 0